/**
 * Internal Error Media Key Status.
 *
 * @group DRM
 *
 * @beta
 */
export const INTERNAL_ERROR = 'internal-error';
